export default "__VITE_ASSET__CEF0kZNY__"